export const QA_NAME_SEARCH_RESULTS_FLATS_TABLE = 'searchResultsFlatsTable'

export const SEARCH_RESULTS_FLATS_CONFIG_API =
  'idwell-api/api/v3/table/tables/flats-search/'

export const SEARCH_RESULTS_FLATS_LIST_API =
  'idwell-api/api/v3/construction/flats/search/'
